// src/components/Soporte/SoporteActivacion.jsx

import React, { useState, useEffect } from 'react';
import VideoModal from './VideoModal';
import './SoporteActivacion.css';

const VIDEOS_ACTIVACION = [
  {
    id: "registro_completo",
    titulo: "Cómo activar tu LemmonTag",
    descripcion: "Aprende el proceso completo en 2 minutos",
    duracion: "2 min",
    url: "https://youtu.be/Lo7-_oDhPeM",
    icon: "🎬"
  },
  {
    id: "confirmar_correo",
    titulo: "¿Por qué confirmar tu correo?",
    descripcion: "Descubre la importancia de este paso",
    duracion: "1 min",
    url: "https://youtu.be/Lo7-_oDhPeM",
    icon: "📧"
  },
  {
    id: "ya_tengo_cuenta",
    titulo: "¿Ya tengo cuenta?",
    descripcion: "Cuándo seleccionar esta opción",
    duracion: "1 min",
    url: "https://youtu.be/Lo7-_oDhPeM",
    icon: "👤"
  },
  {
    id: "agregar_mas_tags",
    titulo: "Cómo agregar más tags",
    descripcion: "Registra tu segundo, tercero o más tags",
    duracion: "1.5 min",
    url: "https://youtu.be/Lo7-_oDhPeM",
    icon: "🏷️"
  }
];

export default function SoporteActivacion({ tipoObjeto = "mascota" }) {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState('inicial'); // 'inicial', 'videos', 'chat'
  const [pregunta, setPregunta] = useState('');
  const [conversacion, setConversacion] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoActual, setVideoActual] = useState(null);

  // Mostrar automáticamente al entrar
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 2000); // Se abre después de 2 segundos

    return () => clearTimeout(timer);
  }, []);

  const handleVerVideo = (video) => {
    setVideoActual(video);
    setShowVideoModal(true);
  };

  const handlePreguntarIA = async () => {
    if (!pregunta.trim()) return;

    const mensajeUsuario = { role: 'user', content: pregunta };
    setConversacion(prev => [...prev, mensajeUsuario]);
    setLoading(true);
    setPregunta('');

    try {
      const response = await fetch('/api/soporte/pregunta', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          pregunta,
          contexto: {
            ubicacion: 'formulario_activacion',
            tipo_objeto: tipoObjeto,
            videos_disponibles: VIDEOS_ACTIVACION
          }
        })
      });

      const data = await response.json();
      
      if (data.success) {
        const mensajeIA = { 
          role: 'assistant', 
          content: data.respuesta,
          videosRelacionados: detectarVideosEnRespuesta(data.respuesta)
        };
        setConversacion(prev => [...prev, mensajeIA]);
      } else {
        throw new Error(data.error);
      }
    } catch (error) {
      console.error('Error:', error);
      setConversacion(prev => [...prev, {
        role: 'assistant',
        content: 'Disculpa, tuve un problema. ¿Puedes intentar de nuevo?'
      }]);
    } finally {
      setLoading(false);
    }
  };

  const detectarVideosEnRespuesta = (respuesta) => {
    // Detectar si la respuesta menciona algún video
    const videosRecomendados = [];
    VIDEOS_ACTIVACION.forEach(video => {
      if (respuesta.toLowerCase().includes(video.id.replace('_', ' ')) ||
          respuesta.toLowerCase().includes(video.titulo.toLowerCase())) {
        videosRecomendados.push(video);
      }
    });
    return videosRecomendados;
  };

  if (!isOpen) {
    return (
      <button
        className="soporte-activacion-btn"
        onClick={() => setIsOpen(true)}
        aria-label="Abrir asistente"
      >
        <i className="bi bi-question-circle"></i>
        <span className="soporte-activacion-badge">💬</span>
      </button>
    );
  }

  return (
    <>
      <div className="soporte-activacion-container">
        <div className="soporte-activacion-header">
          <div className="d-flex align-items-center gap-2">
            <span className="soporte-activacion-avatar">💬</span>
            <div>
              <h6 className="mb-0">Chip - Tu Asistente</h6>
              <small className="text-muted">Siempre aquí para ayudarte</small>
            </div>
          </div>
          <button 
            className="btn-close btn-sm" 
            onClick={() => setIsOpen(false)}
            aria-label="Cerrar"
          ></button>
        </div>

        <div className="soporte-activacion-body">
          {view === 'inicial' && (
            <div className="soporte-activacion-inicial">
              <div className="mensaje-bienvenida">
                <p>¡Hola! 👋</p>
                <p>Veo que estás activando tu <strong>LemmonTag</strong>.</p>
                <p>¿Quieres ver cómo hacerlo?</p>
              </div>

              <div className="d-grid gap-2 mt-3">
                <button 
                  className="btn btn-primary"
                  onClick={() => handleVerVideo(VIDEOS_ACTIVACION[0])}
                >
                  <i className="bi bi-play-circle me-2"></i>
                  Ver video: Cómo activar (2 min)
                </button>
                <button 
                  className="btn btn-outline-primary"
                  onClick={() => setView('videos')}
                >
                  <i className="bi bi-collection-play me-2"></i>
                  Ver más videos
                </button>
                <button 
                  className="btn btn-outline-secondary"
                  onClick={() => setView('chat')}
                >
                  <i className="bi bi-chat-dots me-2"></i>
                  Tengo una pregunta
                </button>
              </div>
            </div>
          )}

          {view === 'videos' && (
            <div className="soporte-activacion-videos">
              <button 
                className="btn btn-sm btn-link mb-3"
                onClick={() => setView('inicial')}
              >
                <i className="bi bi-arrow-left me-1"></i>
                Volver
              </button>

              <h6 className="mb-3">Videos de Ayuda</h6>
              
              <div className="videos-lista">
                {VIDEOS_ACTIVACION.map(video => (
                  <div 
                    key={video.id} 
                    className="video-item"
                    onClick={() => handleVerVideo(video)}
                  >
                    <div className="video-icon">{video.icon}</div>
                    <div className="video-info">
                      <strong>{video.titulo}</strong>
                      <small className="d-block text-muted">{video.descripcion}</small>
                      <span className="badge bg-secondary">{video.duracion}</span>
                    </div>
                    <i className="bi bi-play-circle video-play-icon"></i>
                  </div>
                ))}
              </div>

              <button 
                className="btn btn-outline-secondary btn-sm w-100 mt-3"
                onClick={() => setView('chat')}
              >
                <i className="bi bi-chat-dots me-1"></i>
                ¿Prefieres preguntar directamente?
              </button>
            </div>
          )}

          {view === 'chat' && (
            <div className="soporte-activacion-chat">
              <button 
                className="btn btn-sm btn-link mb-2"
                onClick={() => setView('inicial')}
              >
                <i className="bi bi-arrow-left me-1"></i>
                Volver
              </button>

              <div className="conversacion-container">
                {conversacion.length === 0 && (
                  <div className="mensaje-sistema">
                    <p className="small text-muted">
                      ¡Pregúntame lo que necesites sobre el registro! 😊
                    </p>
                    <div className="preguntas-sugeridas mt-2">
                      <small className="d-block text-muted mb-1">Ejemplos:</small>
                      <button 
                        className="btn btn-sm btn-outline-secondary mb-1"
                        onClick={() => setPregunta('¿Por qué debo confirmar mi correo?')}
                      >
                        ¿Por qué confirmar el correo?
                      </button>
                      <button 
                        className="btn btn-sm btn-outline-secondary mb-1"
                        onClick={() => setPregunta('¿Cómo registro un segundo tag?')}
                      >
                        ¿Cómo registro más tags?
                      </button>
                      <button 
                        className="btn btn-sm btn-outline-secondary mb-1"
                        onClick={() => setPregunta('¿Qué es Ya tengo cuenta?')}
                      >
                        ¿Qué es "Ya tengo cuenta"?
                      </button>
                    </div>
                  </div>
                )}

                {conversacion.map((msg, idx) => (
                  <div 
                    key={idx} 
                    className={`mensaje ${msg.role === 'user' ? 'mensaje-usuario' : 'mensaje-asistente'}`}
                  >
                    {msg.role === 'assistant' && (
                      <span className="mensaje-avatar">💬</span>
                    )}
                    <div className="mensaje-contenido">
                      <p className="mb-0">{msg.content}</p>
                      {msg.videosRelacionados && msg.videosRelacionados.length > 0 && (
                        <div className="videos-relacionados mt-2">
                          {msg.videosRelacionados.map(video => (
                            <button
                              key={video.id}
                              className="btn btn-sm btn-outline-primary mb-1 me-1"
                              onClick={() => handleVerVideo(video)}
                            >
                              <i className="bi bi-play-circle me-1"></i>
                              {video.titulo}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}

                {loading && (
                  <div className="mensaje mensaje-asistente">
                    <span className="mensaje-avatar">🤖</span>
                    <div className="mensaje-contenido">
                      <div className="typing-indicator">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="input-pregunta">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Escribe tu pregunta..."
                  value={pregunta}
                  onChange={(e) => setPregunta(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handlePreguntarIA()}
                  disabled={loading}
                />
                <button
                  className="btn btn-primary"
                  onClick={handlePreguntarIA}
                  disabled={loading || !pregunta.trim()}
                >
                  <i className="bi bi-send"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {showVideoModal && videoActual && (
        <VideoModal
          video={videoActual}
          onClose={() => setShowVideoModal(false)}
        />
      )}
    </>
  );
}